import { RouterStore } from 'mobx-react-router';

export const routerStore = new RouterStore();

export { default as insuranceClauseStore } from './insurance-clause-store';
export { default as insuranceStatementStore } from './insurance-statement-store';
export { default as recordStore } from './recordStore';
